// 初期表示
export const MENU_INIT = "globalNavigation/MENU_INIT";
